import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { firstErrorMessage } from '@/utils/errors';
import VisibilityFilterToggles from '@/components/buttons/VisibilityFilterToggles';
import Filter from '@/components/Filter';
import { fetchSearches, updateSearchesFilter, updateSearchesFlags } from '../actions';

const SearchesFilters = ({
  category,
  privateFlag,
  internalFlag,
  updateFlags,
  filterTerm,
  updateFilterTerm,
  fetchData,
  readErrors,
  className,
  fluid,
}) => (
  <Filter
    fluid={fluid}
    className={clsx('aridhia-searches-filter', className)}
    filterTerm={filterTerm}
    updateFilter={({ value }) => updateFilterTerm(category, value)}
    error={firstErrorMessage(readErrors)}
    onFilter={() => fetchData(category, 1, null, false)}
    label={(
      <VisibilityFilterToggles
        entity="searches"
        privateFlag={privateFlag}
        internalFlag={internalFlag}
        updateFlags={(flags) => updateFlags(category, flags)}
      />
)}
  />
);

const mapStateToProps = ({
  search: { searches },
}, { category }) => {
  const {
    filter, privateFlag, internalFlag, readErrors,
  } = searches[category];

  return ({
    filterTerm: filter,
    privateFlag,
    internalFlag,
    readErrors,
  });
};

const mapDispatchToProps = {
  updateFlags: updateSearchesFlags,
  updateFilterTerm: updateSearchesFilter,
  fetchData: fetchSearches,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchesFilters);
